import { LngLat } from 'mapbox-gl';
import { makeAutoObservable } from 'mobx';
import IParcel from '../interfaces/IParcel';

export default class ContextMenuStore {
    coordinates: LngLat | null = null;
    pageCoordinates: IPageCoordinates | null = null;
    onAddParcel: ((coordinates: LngLat) => void) | null = null;
    onRemoveParcel: ((parcelId: string) => void) | null = null;
    showDefaultOptions = false;
    findParcelAtCoordinate: ((coordinates: LngLat) => IParcel | undefined) | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    open(coordinates: LngLat, pageCoordinates: IPageCoordinates) {
        this.coordinates = coordinates;
        this.pageCoordinates = pageCoordinates;
    }

    close() {
        this.coordinates = null;
        this.pageCoordinates = null;
    }

    setOnAddParcel(value: (coordinates: LngLat) => void, showDefaultOptions = false) {
        this.onAddParcel = value;
        this.showDefaultOptions = showDefaultOptions;
    }

    clearOnAddParcel() {
        this.onAddParcel = null;
        this.showDefaultOptions = false;
    }

    setOnRemoveParcel(
        value: (parcelId: string) => void,
        findParcel: (coordinates: LngLat) => IParcel | undefined,
    ) {
        this.onRemoveParcel = value;
        this.findParcelAtCoordinate = findParcel;
    }

    clearOnRemoveParcel() {
        this.onRemoveParcel = null;
        this.findParcelAtCoordinate = null;
    }

    addParcel(coordinates: LngLat) {
        this.onAddParcel?.(coordinates);
    }

    removeParcel(parcelId: string) {
        this.onRemoveParcel?.(parcelId);
    }

    clear() {
        this.close();
        this.clearOnAddParcel();
        this.clearOnRemoveParcel();
    }
}

interface IPageCoordinates {
    x: number;
    y: number;
}
